import Vue from 'vue'
import VueRouter from 'vue-router'
import BaseLayout from '../layout/base/index.vue'
import CheckoutLayout from '../layout/checkout/index.vue'
import SDKCheckoutLayout from '../layout/sdk/index.vue'
import SubscribeLayout from '../layout/subscribe/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/dispute',
    name: 'Base',
    component: BaseLayout,
    children: [
      {
        path: 'apply',
        name: 'DisputeApply',
        component: () => import('@/views/dispute/apply/index.vue')
      },
      {
        path: 'chat',
        name: 'DisputeChat',
        component: () => import('@/views/dispute/chat/index.vue')
      }
    ]
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: CheckoutLayout,
    children: [
      {
        path: ':id',
        name: 'CheckoutPayment',
        component: () => import('@/views/checkout/payment/index.vue'),
        meta: { title: 'Checkout' }
      },
      {
        path: 'qr-code/:id',
        name: 'CheckoutQrCode',
        component: () => import('@/views/checkout/payment/qr-code/index.vue'),
        meta: { title: 'Checkout' }
      },
      {
        path: 'pending/:id',
        name: 'CheckoutPending',
        component: () => import('@/views/checkout/result/index.vue'),
        meta: { title: 'Checkout' }
      },
      {
        path: 'success/:id',
        name: 'CheckoutSuccess',
        component: () => import('@/views/checkout/result/index.vue'),
        meta: { title: 'Checkout' }
      },
      {
        path: 'failed/:id',
        name: 'CheckoutFailed',
        component: () => import('@/views/checkout/result/index.vue'),
        meta: { title: 'Checkout' }
      }
    ]
  },
  {
    path: '/sdk-payment',
    name: 'SDK Payment',
    component: SDKCheckoutLayout,
    children: [
      {
        path: 'number/:id',
        name: 'SDK Payment Number',
        component: () => import('@/views/sdk/card-number/index.vue'),
        meta: { title: 'SDK Number' }
      },
      {
        path: 'date/:id',
        name: 'SDK Payment Date',
        component: () => import('@/views/sdk/expiration-date/index.vue'),
        meta: { title: 'SDK Date' }
      },
      {
        path: 'code/:id',
        name: 'SDK Payment CVV',
        component: () => import('@/views/sdk/security-code/index.vue'),
        meta: { title: 'SDK CVV' }
      }
    ]
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/subscribe',
    name: 'Subscribe',
    component: SubscribeLayout,
    children: [
      {
        path: ':id',
        name: 'Unsubscribe',
        component: () => import('@/views/subscribe/unsubscribe/index.vue'),
        meta: { title: 'Unsubscribe' }
      },
      {
        path: 'failed/:id',
        name: 'SubscribeFailed',
        component: () => import('@/views/subscribe/unsubscribe/failed/index.vue'),
        meta: { title: 'Subscribe Failed' }
      }
    ]
  },
  {
    path: '/test-checkout',
    name: 'Test Checkout',
    component: () => import('@/views/checkout/test/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = 'Service Platform'
  }
  next()
})

export default router
